// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./LoadingBoxTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingBox-module__Container__L8ih8 {
    background-color: inherit;
}

.LoadingBox-module__CoverPage__vAw1r {
    width: 100vw;
    height: 100vh;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `LoadingBox-module__Container__L8ih8`,
	"CoverPage": `LoadingBox-module__CoverPage__vAw1r`
};
export default ___CSS_LOADER_EXPORT___;
